var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { "data-grm-comp": "RoomCBTLogUserList" } }, [
    _c("table", [
      _vm._m(0),
      _vm._m(1),
      _c(
        "tbody",
        [
          _vm._l(_vm.cbtLog.roomCbtUserLogList, function (roomCbtUser) {
            return _c("tr", { key: roomCbtUser.userId }, [
              _c("td", [_vm._v(_vm._s(roomCbtUser.username))]),
              _c("td", [_vm._v(_vm._s(roomCbtUser.totalScore))]),
              _c("td", [
                _vm._v(
                  _vm._s(
                    _vm
                      .dayjs(roomCbtUser.beginDate)
                      .format("YYYY-MM-DD HH:mm:ss")
                  ) +
                    " ~ " +
                    _vm._s(
                      _vm
                        .dayjs(roomCbtUser.endDate)
                        .format("YYYY-MM-DD HH:mm:ss")
                    )
                ),
              ]),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "flex justify-center items-center gap-1" },
                  [
                    _c(
                      "GrmBtn",
                      {
                        attrs: { size: "xs" },
                        on: {
                          click: function ($event) {
                            return _vm.onSelectCBT(roomCbtUser)
                          },
                        },
                      },
                      [_vm._v("보기")]
                    ),
                  ],
                  1
                ),
              ]),
            ])
          }),
          _vm.cbtLog.roomCbtUserLogList.length === 0
            ? _c("tr", [
                _c("td", { attrs: { colspan: "4" } }, [
                  _vm._v("출제한 사용자가 없습니다."),
                ]),
              ])
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "10%" } }),
      _c("col", { attrs: { width: "3%" } }),
      _c("col", { attrs: { width: "10%" } }),
      _c("col", { attrs: { width: "3%" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("이름")]),
        _c("th", [_vm._v("점수")]),
        _c("th", [_vm._v("참여 시간")]),
        _c("th", [_vm._v("결과 보기")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }